const LIGHT_MODE_COLORS: string[] = [
  '#0057B2',
  '#455A64',
  '#0097A7',
  '#E64A19',
  '#512DA8',
  '#388E3C',
  '#303F9F',
  '#0288D1',
  '#689F38',
  '#9E9D24',
  '#F57C00',
  '#C2185B',
  '#7B1FA2',
  '#D32F2F',
  '#00796B',
];

const DARK_MODE_COLORS: string[] = [
  '#4A90E2',
  '#7E8E99',
  '#4DD0E1',
  '#FF7043',
  '#9575CD',
  '#66BB6A',
  '#5C6BC0',
  '#42A5F5',
  '#9CCC65',
  '#D4E157',
  '#FFA726',
  '#EC407A',
  '#BA68C8',
  '#EF5350',
  '#26A69A',
];

export const getConsistentAvatarBackgroundColor = (
  userId: string | undefined,
  isDarkMode = false
): string => {
  const colors = isDarkMode ? DARK_MODE_COLORS : LIGHT_MODE_COLORS;
  if (!userId) return colors[0];
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash << 5) - hash + userId.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

export const AVATAR_STYLES = {
  size: {
    width: 32,
    height: 32,
  },
  fontSize: 14,
} as const;
